import { colors } from "@/shared/design-system";
import { useSupportChat } from "@/features/support";
import { AppText, Card } from "@/shared/ui";

/**
 * Bloc d'aide — pied de la colonne contextuelle.
 *
 * Le bouton ouvre le même chat tawk.to que la ligne « Contacter le support »
 * du profil et l'icône du header. Les trois entrées partagent le même service :
 * un seul script, une seule identité et une seule conversation.
 */
export function SupportPanel() {
  const supportChat = useSupportChat();

  return (
    <Card className="p-4">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <AppText as="h2" variant="smallStrong" color={colors.navy800}>
            Besoin d'aide ?
          </AppText>
          <AppText as="p" variant="tiny" color={colors.gray500}>
            Notre équipe est disponible pour vous.
          </AppText>
        </div>
        <span className="shrink-0" style={{ fontSize: 34, lineHeight: 1 }} aria-hidden>
          🎧
        </span>
      </div>

      {/* Pilule discrète, calée à gauche : c'est une porte de sortie, pas le CTA
          de la page — le composant `Button` du DS impose une hauteur de 56px et
          un poids visuel qui volerait la vedette à « Suivre la course ». */}
      <button
        type="button"
        onClick={() => void supportChat.openChat()}
        disabled={supportChat.isOpening}
        className="mt-3 rounded-full bg-or-50 px-4 py-2 transition-colors hover:bg-or-100 disabled:cursor-wait disabled:opacity-60"
      >
        <AppText variant="tinyBold" color={colors.navy800}>
          {supportChat.isOpening ? "Ouverture du chat…" : "Contacter le support"}
        </AppText>
      </button>
    </Card>
  );
}
